<template>
	<div>
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: "Access",

		props: {
			name: {
				type: String,
				default: ""
			}
		},

		access(){
			return this.name
		}
	}
</script>